import AddressForm from 'shared/components/organisms/AddressForm/AddressForm';

export default AddressForm;
